import React from 'react';
import DragHandle, {
  HANDLE_POSITIONS
} from '../../../components/wysiwyg_editor/page_content_items/DragHandle';
import { animated, SpringValue } from '@react-spring/web';
import type { TSprungOverlayLocations } from '../../../utils/wysiwyg_editor/contentItemHandleLocations';

type TProps = {
  pageItemId: string;
  location: TSprungOverlayLocations;
  zIndex: number;
  onClick?: () => void;
  onMouseDown?: () => void;
  onDrag: (
    position: string,
    movement: [number, number],
    isFirst: boolean,
    isLast: boolean
  ) => void;
  onDragStart: () => void;
  onDragStop: () => void;
  onPointerEnter?: () => void;
  onPointerLeave?: () => void;
  onPointerUp?: () => void;
};

function ContentDragShield(props: TProps): React.ReactElement {
  return (
    <DragHandle
      top={props.location.y}
      left={props.location.x}
      height={props.location.height}
      width={props.location.width}
      paddedTop={props.location.y}
      paddedLeft={props.location.x}
      paddedHeight={props.location.height}
      paddedWidth={props.location.width}
      pageItemId={props.pageItemId}
      position={HANDLE_POSITIONS.inner}
      zIndex={props.zIndex}
      onClick={props.onClick}
      onMouseDown={props.onMouseDown}
      onDrag={props.onDrag}
      onDragStart={props.onDragStart}
      onDragStop={props.onDragStop}
    >
      <animated.div
        style={{
          position: 'absolute',
          height: props.location.height,
          width: props.location.width,
          zIndex: props.zIndex
        }}
        onMouseDown={props.onMouseDown}
        onPointerEnter={props.onPointerEnter}
        onPointerLeave={props.onPointerLeave}
        onPointerUp={props.onPointerUp}
        touch-action="none"
      />
    </DragHandle>
  );
}

export default ContentDragShield;
